module.exports = __webpack_public_path__ + "img/M300.79fedc98.png";